import { Link } from "react-router-dom";
import "./AbsencesDetails.css";
import BackButton from "../../../../../sharedComponents/backButton/BackButton";
import { CustomProvider, DatePicker, SelectPicker } from "rsuite";
import de_DE from 'rsuite/locales/de_DE';
import { useEffect, useState } from "react";
import axios from "axios";
import LoadingSpinner from "../../../../../sharedComponents/LoadingSpinner/LoadingSpinner";
import { DataGrid } from '@mui/x-data-grid';
import formatDuration from "../../../../../sharedComponents/FormatDuration";
import parseDuration from "../../../../../sharedComponents/ParseDuration";
import PrimaryButton from "../../../../../sharedComponents/primaryButton/PrimaryButton";
import { Tab, Tabs } from "react-bootstrap";
import FilterArea from "../../../../../sharedComponents/filterArea/FilterArea";

const columns = [
    { field: 'firstName', headerName: 'Vorname', width: 150 },
    { field: 'lastName', headerName: 'Nachname', width: 150 },
    { field: 'type', headerName: "Art", width: 120 },
    { field: 'startTime', headerName: "Start", width: 120 },
    { field: 'endTime', headerName: "Ende", width: 120 },
    { field: 'countOfAbsenceDays', headerName: "Abwesenheitstage", width: 150 },
    { field: 'durationPerDay', headerName: "Stunden pro Abwesenheitstag", width: 200 },
    { field: 'paid', headerName: "Bezahlt", width: 100 },
];

function AbsencesDetails() {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [absences, setAbsences] = useState([]);
    const [selectedTab, setSelectedTab] = useState("0");

    const [selectedArea, setSelectedArea] = useState(null);

    useEffect(() => {
        fetchAbsences();
    }, [selectedTab, selectedMonth, selectedYear]);

    const fetchAbsences = () => {
        setIsLoading(true);
        setHasError(false);

        const year = selectedYear;
        let month = null;

        if (selectedTab === "0" && selectedMonth) {
            month = (selectedMonth.getMonth() + 1).toString().padStart(2, '0');
        }

        axios.get(`absence/getAbsencePeriodsForAllEmployees?year=${year}${month ? `&month=${month}` : ''}`)
            .then(results => {
                setAbsences(results.data || []);
                setIsLoading(false);
            })
            .catch(() => {
                setHasError(true);
                setIsLoading(false);
            });
    };

    const flatAndSortAbsences = () => {
        const flattenedAbsences = absences.flatMap(absence =>
            (absence.absencePeriods || []).map(period => ({
                ...period,
                employeeFirstName: absence.employeeFirstName,
                employeeLastName: absence.employeeLastName,
                employeeId: absence.employeeId,
            }))
        );

        return flattenedAbsences.sort((a, b) => new Date(a.absenceDays[0].date) - new Date(b.absenceDays[0].date));
    };

    const generateRows = () => {
        let rows = [];

        flatAndSortAbsences().forEach(absence => {
            if(selectedArea !== null && !selectedArea.assigned_employee_ids.includes(absence.employeeId)){
                return null;
            }

            const absenceDays = absence.absenceDays.sort((a, b) => new Date(a.date) - new Date(b.date));
            let row = {
                id: absence.id,
                firstName: absence.employeeFirstName,
                lastName: absence.employeeLastName,
                type: absence.absenceType,
                startTime: new Date(absenceDays[0].date).toLocaleDateString("de-DE", { day: '2-digit', month: '2-digit', year: 'numeric' }),
                endTime: new Date(absenceDays[absenceDays.length - 1].date).toLocaleDateString("de-DE", { day: '2-digit', month: '2-digit', year: 'numeric' }),
                countOfAbsenceDays: absenceDays.length,
                durationPerDay: formatDuration(parseDuration(absenceDays[0].duration)),
                paid: absence.paid ? "Ja" : "Nein",
            };
            rows.push(row);
        });

        return rows;
    };

    const generateDataTable = () => {
        return isLoading ?
            <LoadingSpinner />
            :
            hasError ?
            <p>Ein Fehler ist aufgetreten</p>
            :
            <DataGrid
                rows={generateRows()}
                columns={columns}
                disableRowSelectionOnClick
                hideFooterPagination
                density="compact"
                disableColumnMenu
                hideFooter
                className="absences-data-grid"
            />
    };

    const changeTab = (tabIndex) => {
        setSelectedTab(tabIndex);
        if (tabIndex === 1) {
            setSelectedMonth(null);
        }
    };

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear - 10; year <= currentYear + 10; year++) {
            years.push({ label: year.toString(), value: year });
        }
        return years;
    };

    return (
        <div className="absences-details-container">
            <Link to={'/home/dashboard'}>
                <div className="absences-header-container">
                    <BackButton text="Zurück" />
                </div>
            </Link>
            <div className="absences-dashboard">
                <div className="absences-dashboard-header">
                    <h3>Abwesenheiten</h3>
                    <PrimaryButton text="Drucken" onClick={() => window.print()} />
                    <FilterArea selectedArea={selectedArea} setSelectedArea={setSelectedArea} />
                </div>
                <Tabs activeKey={selectedTab} onSelect={changeTab} className="absences-tabs" variant="tabs">
                    <Tab eventKey={0} title="Monatlich">
                        <CustomProvider locale={de_DE}>
                            <DatePicker
                                className="dashboard-datepicker"
                                cleanable={false}
                                label="Ausgewählter Monat"
                                oneTap
                                required
                                format="MMM yyyy"
                                size="lg"
                                placeholder="Startmonat"
                                value={selectedMonth}
                                onSelect={(value) => setSelectedMonth(value)}
                            />
                        </CustomProvider>
                    </Tab>
                    <Tab eventKey={1} title="Jährlich">
                        <SelectPicker
                            data={generateYearOptions()}
                            style={{ width: 200 }}
                            value={selectedYear}
                            onChange={(value) => setSelectedYear(value)}
                            cleanable={false}
                            placeholder="Ausgewähltes Jahr"
                        />
                    </Tab>
                </Tabs>
                {generateDataTable()}
            </div>
        </div>
    );
}

export default AbsencesDetails;